import { render, staticRenderFns } from "./JudgeNav.vue?vue&type=template&id=387a874a&scoped=true&"
import script from "./JudgeNav.vue?vue&type=script&lang=js&"
export * from "./JudgeNav.vue?vue&type=script&lang=js&"
import style0 from "./JudgeNav.vue?vue&type=style&index=0&id=387a874a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a874a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
